import { TopicJob } from '@doda/pc/src/pages/DodaFront/View/FeaturedJobList/types';

/**
 * キーワード生成のための引数を表すインターフェース
 */
interface GetKeywordArgs {
  /** 求人タイトル */
  title: TopicJob['title'];
  /** 現在のページ番号 */
  currentPage: number;
  /** 現在のページの開始件数 */
  fromCount: number;
  /** 現在のページの終了件数 */
  toCount: number;
}

/**
 * キーワードを生成する関数
 *
 * @param {GetKeywordArgs} params - 引数のオブジェクト
 * @returns {string} 生成されたキーワードの文字列
 */
export const getKeyword = ({
  title,
  currentPage,
  fromCount,
  toCount,
}: GetKeywordArgs) => {
  if (!title) return `求人特集,転職,求人,求人情報`;

  if (currentPage >= 2) {
    return `${currentPage}ページ,${fromCount}件-${toCount}件,${title},転職,求人,求人情報`;
  }
  return `${title},転職,求人,求人情報`;
};
